import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const citizenFillableFormResponseFields = `
id
uniqueId
responsePayload
form {
  id
  uniqueId
  name
  description
  configuration
  isActive
  isPublished
  createdAt
  service {
    id
    serviceUniqueId
    serviceName
  }
  formApiHtmlBody
  formApiDetails {
    id
    formApiUniqueId
    formApiDescription
    formRequiresAuth
    formApiAuthType
    formApiKey
    formJwtToken
    formClientId
    formClientSecret
    formApiUrl
  }
}
serviceUniqueId
userUniqueId
`



export const CREATE_CITIZEN_FILLABLE_FORM_RESPONSE = gql`
  mutation CreateFormResponseMutation($input: FormResponseInputObjects!) {
    createFormResponseMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${citizenFillableFormResponseFields}
      }
    }
  }
`

